module.exports = __webpack_public_path__ + "8a306e002f4cc1b667ba52755ee8784c.enjoy.svg";